export enum FundingMethodEnum {
  Bank = 'ACH',
  None = 'NONE',
  Empty = '',
}

export enum OAAccountTypes {
  InheritedIRA = 'A',
  InheritedRothIRA = 'B',

  TraditionalIRA = '0',
  SepIRA = '2',
  RothIRA = '4',
  SimpleIRA = '5',

  Individual = '00',
  Joint = '01',
  Trust = '02',
  UGMA_UTMA = '04',

  Vanguard529Plan = '529',
  Individual401 = '401k',
  VariableAnnuity = 'IRAA',

  UNKNOWN = '',
}

export enum SuffixEnum {
  None = '',
  JR = 'JR',
  SR = 'SR',
  II = 'II',
  TH = 'TH',
  FO = 'FO',
}

export enum SuffixValuesEnum {
  None = '',
  JR = 'Jr.',
  SR = 'Sr.',
  II = 'II',
  TH = 'III',
  FO = 'IV',
}

export enum CitizenshipStatusEnum {
  None = '',
  UsCitizen = 'US_CITIZEN',
  ResidentAlien = 'RESIDENT_ALIEN',
  NonresidentAlien = 'NON_RESIDENT_ALIEN',
}
